import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { AlertPopup } from "./AlertPopup";
import axios from "axios";
import { genURL } from './../_getjson';

export default class _popupissuereq extends React.Component {
  state = {
    type: this.props.type,
    col: [],
    rows: [],
    valueRetuen: "",
    Htext: "",
    SHtype: 3,
    SELECTALLCLICK: 0
  };
  async componentDidMount() {
    // console.log(this.props.datatable);
    let url
    switch (this.props.type) {
      case "subPopup":
        url = "CSSTKISSUEREQ/Subpopup?" + this.props.datatable;
        var dataArray = [];
        await axios.get(genURL(url)).then(res => {
          let data = res.data;
          console.log(data);
          if (data.length > 0) {
            for (let j = 0; j < data.length; j++) {
              dataArray[j] = {
                number: j + 1,
                C0: 0,
                C1: data[j].DOCNO,
                C2: data[j].PRODUCTCODE,
                C3: data[j].PRODUCTNAME,
                C4: data[j].UNITNAME,
                C5: data[j].REFQTY,
                C6: data[j].WAREHOUSE,
                C7: data[j].LOCATION,
                UNITCODE: data[j].UNITCODE,
                REFLINEID: data[j].REFLINEID,
                REFDOCTYPE: data[j].REFDOCTYPE,
                STOCKTYPE: data[j].STOCKTYPE,
                PRODUCTSET: data[j].PRODUCTSET,
                REFQTY: data[j].REFQTY
              };
            }
          }
        }).finally(_ => {
          this.setState({ rows: dataArray });
        });

        // var url = "CSSTKISSUEREQ/DOCNO?DOCNO=" + ;
        // var dataArray = [];
        // GetCorServicei(url, "").then(res => {
        //     let data = res.data;
        //     for (let index = 0; index < data.length; index++) {
        //         dataArray[index] = {
        //             number: index + 1,
        //             C0: 0,
        //             C1: data[index].DOCNO,
        //             C2: this._newDate(data[index].DOCDATE),
        //             C3: this._newDate(data[index].DUEDATE),
        //             C4: data[index].USERNAME,
        //             C5: data[index].ISSUENAME,
        //             C6: data[index].REMARK,
        //             C7: data[index].ARNAME,

        //         }
        //     }
        //     setTimeout(() => {
        //         this.setState({ rows: dataArray });
        //         console.log(this.state.rows);

        //     }, 30);

        // });
        // this.setState({ Htext: "ค้นหาใบเบิกสินค้า" });
        break;
      default: break;
    }
  }
  _newDate = txtDate => {
    let dt = new Date(txtDate);
    let date_ = dt.getDate();
    let mouth_ = dt.getMonth();
    let year_ = Number(dt.getUTCFullYear()) + 543;
    return date_ + "/" + mouth_ + "/" + year_;
  };
  onSearch = e => {
    // var dataArray = [];
    // var Url = GetContractno(e.target.value,2,this.state.SHtype);
    // switch (this.props.type) {
    //     case 'Contractno':
    //         Url = GetContractno(e.target.value,2,this.state.SHtype);
    //     break;
    //     case 'Chassisno':
    //         Url = GetChassisno(e.target.value,2,this.state.SHtype);
    //     break;
    // }
    // axios.get(Url).then(
    //     res =>{
    //         var dataArray = [];
    //         if(res.data.length >0){
    //             for(var i =0 ; i<res.data.length;i++){
    //                 dataArray[i]={
    //                     number: i+1,
    //                     code:res.data[i].regisno,
    //                     text:res.data[i].prefix+res.data[i].arname+" "+res.data[i].lname,
    //                     chassisno:res.data[i].chassisno,
    //                     contractno:res.data[i].contractno,
    //                 }
    //             }
    //             this.setState({rows : dataArray});
    //         }else{
    //             this.setState({rows : dataArray});
    //         }
    //     }
    // );
  };

  onSelectRow = (data, col, id) => {
    if (col > 1) {
      //เท่ากับเลือกรายการเมื่อคลิกแถว
      var dataArray = this.state.rows;
      dataArray[id].C0 = 1;
      this.setState({ rows: dataArray });
      //------------------------
      let col = this.state.rows;
      let return_ = [];
      let j = 0;
      for (let i = 0; i < col.length; i++) {
        if (col[i].C0 === 1) {
          return_[j] =
            col[i].C1 + "|" +
            col[i].C2 + "|" +
            col[i].C3 + "|" +
            col[i].C4 + "|" +
            col[i].C5 + "|" +
            col[i].C6 + "|" +
            col[i].C7 + "|" +
            this.props.ARCODE + "|" +
            this.props.ARNAME + "|" +
            this.props.SITECODE + "|" +
            this.props.ISSUETYPE + "|" +
            this.props.DEPARTMENT + "|" +
            this.props.ISSUENAME + "|" +
            this.props.REMARK + "|" +
            col[i].UNITCODE + "|" +
            col[i].REFLINEID + "|" +
            col[i].REFDOCTYPE + "|" +
            col[i].STOCKTYPE + "|" +
            col[i].PRODUCTSET + "|" +
            col[i].REFQTY
          j++;
        }
      }
      // console.log(return_); 
      if (return_.length > 0) {
        /* setTimeout(() => { */
        this.props.Get_PopUpOther(return_);
        this.props.closePopup();
        /* }, 50); */
      } else {
        AlertPopup("Error", "กรุณาเลือกข้อมูลที่ต้องการ");
      }
    }
  };
  onChangeRadio = e => {
    this.setState({ SHtype: e.target.value });
  };
  _cSelect = (data) => {
    // console.log(data);
    let col = this.state.rows;
    let return_ = [];
    let j = 0;
    for (let i = 0; i < col.length; i++) {
      if (col[i].C0 === 1) {
        return_[j] =
          col[i].C1 + "|" +
          col[i].C2 + "|" +
          col[i].C3 + "|" +
          col[i].C4 + "|" +
          col[i].C5 + "|" +
          col[i].C6 + "|" +
          col[i].C7 + "|" +
          this.props.ARCODE + "|" +
          this.props.ARNAME + "|" +
          this.props.SITECODE + "|" +
          this.props.ISSUETYPE + "|" +
          this.props.DEPARTMENT + "|" +
          this.props.ISSUENAME + "|" +
          this.props.REMARK + "|" +
          col[i].UNITCODE + "|" +
          col[i].REFLINEID + "|" +
          col[i].REFDOCTYPE + "|" +
          col[i].STOCKTYPE + "|" +
          col[i].PRODUCTSET + "|" +
          col[i].REFQTY


        j++;
      }
    }
    // console.log(return_); 
    if (return_.length > 0) {
      setTimeout(() => {
        this.props.Get_PopUpOther(return_);
        this.props.closePopup();
      }, 50);
    } else {
      AlertPopup("Error", "กรุณาเลือกข้อมูลที่ต้องการ");
    }
  };
  cellcheckbox = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.rows[rowIndex].C0;
    var btnShow = "";
    switch (btn) {
      case 0:
        btnShow = (
          <span>
            <i class="far fa-square " onClick={this._updateStatus.bind(null, rowIndex, 1)}></i>
          </span>
        );
        break;
      case 1:
        btnShow = (
          <span>
            <i class="far fa-check-square" onClick={this._updateStatus.bind(null, rowIndex, 0)}></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i class=""></i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  _updateStatus = (rowIndex, val) => {
    if (rowIndex !== "selectAll") {
      let col = this.state.rows;
      col[rowIndex].C0 = val;
      this.setState({ rows: col });
    } else {
      this.setState({ SELECTALLCLICK: val });
      let colSA = this.state.rows;
      for (let i = 0; i < colSA.length; i++) {
        colSA[i].C0 = val;
      }
      this.setState({ rows: colSA });
    }
  };
  render() {

    // const selectRowProp = {
    //   mode: "checkbox",
    //   clickToSelect: true,
    //   onSelect: this.onRowSelect,
    //   onSelectAll: this.onSelectAll
    // };
    return (
      <div className="popup" style={{ "z-index": "100" }}>
        <div className="popup_inner">
          {this.props.Data}
          <div class="PopUpOtherDivH" align="left">
            <div class="PopUpOtherDivH1">
              <i class="fas fa-search"> ค้นหาใบเบิกสินค้า </i>
            </div>
            <div class="PopUpOtherDivH2">
              <i class="fas fa-times" onClick={this.props.closePopup}></i>
            </div>
          </div>
          <div class="panel-body divTable" align="right">
            {/* <div class=" ">
              <div className="col-md-6" align="left">
                <button  type="button"  class="btn btn-success"  onClick={this._cSelect.bind(this)}>  ตกลง</button>
              </div>
              <div className="col-md-6" align="right">
                <div class="input-group searchinput ">
                  <input  id="id1"  type="text"  class="form-control "  onChange={this.onSearch}/>
                  <span class="input-group-addon icon">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div> */}
            <div style={{ marginTop: "10px" }} >
              <BootstrapTable
                data={this.state.rows}
                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา" }}
                height="520"
                hover condensed search>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="40" dataField="number" isKey></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30" dataAlign="center" dataField="C0" dataFormat={this.cellcheckbox.bind(this)}>
                  <i class={this.state.SELECTALLCLICK === 0 ? "far fa-square" : "far fa-check-square"}
                    onClick={this.state.SELECTALLCLICK === 0 ? this._updateStatus.bind(null, "selectAll", 1) : this._updateStatus.bind(null, "selectAll", 0)}  >
                  </i>
                </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="180" dataField="C1"> ใบขอเบิก</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="C2">    รหัสสินค้า</TableHeaderColumn>
                {/* {this.state.showSH===true? */}
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="250" dataField="C3">    ชื่อสินค้า</TableHeaderColumn>
                {/* :null} */}
                {/* {this.state.showSH===true? */}
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="C4">  หน่วยนับ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="C5">  ปริมาณ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="C6" hidden>  คลัง</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="C7" hidden>  ตำแหน่ง</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="UNITCODE" hidden>  UNITCODE</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="REFLINEID" hidden>  REFLINEID</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REFDOCTYPE'> REFDOCTYPE </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REFQTY'> REFQTY </TableHeaderColumn>
              </BootstrapTable>
            </div>
            {this.state.TableHidden ? ("") : (
              <button class="PUSDbtn" onClick={this.props.closePopup} >
                <i class="fas fa-reply-all"> กลับ </i>
              </button>
            )}
            <button class="PUSDbtn" onClick={this._cSelect.bind(this)}>
              <i class="fas fa-check"> ตกลง </i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
